// Scroll reveal: content fades up once as it enters the viewport.
// Skips the first two sections (hero and proof line), marquees and jumbo text,
// which have their own motion. Does nothing when reduced motion is requested.
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sections = [...document.querySelectorAll('main > .shopify-section')].slice(2);
  const targets = [];

  for (const section of sections) {
    if (section.querySelector('marquee-component, jumbo-text')) continue;
    let items = section.querySelectorAll('.resource-list__item, .samad-journal__card');
    if (!items.length) items = section.querySelectorAll('.section-content-wrapper > *');
    if (!items.length) items = [section];
    [...items].forEach((el, i) => {
      el.style.setProperty('--sr-i', Math.min(i, 5));
      targets.push(el);
    });
  }

  const fold = window.innerHeight;
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('sr-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const el of targets) {
    // Anything already on screen at load stays put, so nothing flashes.
    if (el.getBoundingClientRect().top < fold) continue;
    el.classList.add('sr');
    observer.observe(el);
  }

  // A fast flick or a jump link can carry an element past the viewport without it ever
  // intersecting; reveal anything whose top is already above the bottom of the screen.
  let pending = false;
  const sweep = () => {
    pending = false;
    const pendingEls = document.querySelectorAll('.sr:not(.sr-in)');
    if (!pendingEls.length) return window.removeEventListener('scroll', onScroll);
    for (const el of pendingEls) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('sr-in');
        observer.unobserve(el);
      }
    }
  };
  const onScroll = () => {
    if (!pending) {
      pending = true;
      requestAnimationFrame(sweep);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();
